import { useContext } from "react";
import { SelectionDetails } from "@src/lib/sync-engine/operations/GetSelection";
import { WalterContext } from "@src/taskpane/providers/walter";

export function useSelectionDetails(): SelectionDetails {
  const { documentSelectionData } = useContext(WalterContext);

  return documentSelectionData;
}
